var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { IntegrationsImportService } from '../integration.import.service';
import { ActivatedRoute } from '@angular/router';
import { IntegrationImportErrorColumn, Order } from "../integration-imports.interface";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { GetIntegrationImportErrorsAction } from "../integration-imports.actions";
import { Store } from "@ngrx/store";
import { getIntegrationImportErrorsDataSelector, getIntegrationImportErrorsParamsSelector } from "../integration-imports.reducer";
import { Location } from "@angular/common";
var IntegrationImportErrorsComponent = /** @class */ (function () {
    function IntegrationImportErrorsComponent(integrationsImportService, route, store, location) {
        this.integrationsImportService = integrationsImportService;
        this.route = route;
        this.store = store;
        this.location = location;
        this.pageSizeOptions = [10, 20, 100];
        this.displayedColumns = ['sourceObjectId', 'msisdn', 'reason'];
    }
    IntegrationImportErrorsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dataSource = new MatTableDataSource([]);
        this.store.select(getIntegrationImportErrorsParamsSelector).subscribe(function (params) {
            _this.params = params;
            if (_this.params && _this.params.pager) {
                var _a = _this.params.pager || {}, limit = _a.limit, page = _a.page;
                _this.paginator.pageSize = limit;
                _this.paginator.pageIndex = page - 1;
            }
        });
        this.store.select(getIntegrationImportErrorsDataSelector).subscribe(function (errors) {
            _this.dataSource.data = errors.data;
            _this.total = errors.total;
            _this.paginator.length = errors.total;
        });
    };
    IntegrationImportErrorsComponent.prototype.sortChange = function ($event) {
        this.store.dispatch(new GetIntegrationImportErrorsAction(__assign({}, this.params, { order: $event.direction ? Order[$event.direction.toUpperCase()] : null, sortBy: IntegrationImportErrorColumn[$event.active] })));
    };
    IntegrationImportErrorsComponent.prototype.onPageChange = function (event) {
        this.params.pager = {
            limit: event.pageSize,
            page: event.pageIndex + 1
        };
        this.store.dispatch(new GetIntegrationImportErrorsAction(this.params));
    };
    IntegrationImportErrorsComponent.prototype.back = function () {
        this.location.back();
    };
    return IntegrationImportErrorsComponent;
}());
export { IntegrationImportErrorsComponent };
